import { render } from "./TakEoutos.vue?vue&type=template&id=12fd6704"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEoutos.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12fd6704"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12fd6704', __exports__)) {
    api.reload('12fd6704', __exports__)
  }
  
  module.hot.accept("./TakEoutos.vue?vue&type=template&id=12fd6704", () => {
    api.rerender('12fd6704', render)
  })

}


export default __exports__